import styles from "./field-error.module.css";

export const fieldErrorBorderClass = styles.fieldErrorBorder;

export const fieldErrorWrapperClass = styles.fieldErrorWrapper;

export const FieldErrorMessage = ({
	children = "Required",
}: {
	children?: React.ReactNode;
}) => <span className={styles.fieldErrorMessage}>{children}</span>;
